<ng-container *transloco="let t; read: 'user'">
<div class="flex flex-row p-2">
  <h1 class="userProfile font-semibold">{{ t('userProfile.password.pageTitle') }}</h1>
</div>
<div class="place-content-center mr-5">
  <drdp-container>
    <div class="w-full">
      <div
      class="
      lg:flex
      place-content-between place-items-start
      border-b border-drdpgrey-100
      self-center
      hidden
    ">
        <h1 class="information font-semibold mb-2">{{ t('userProfile.password.sectionTitle') }}</h1>
      </div>

      <form
        [formGroup]="passwordForm"
        (ngSubmit)="onSubmit()"
        >
        <div class="pt-5">
          <label>{{ t('userProfile.password.current') }} <span class="required"></span> </label>
          <div class="grid grid-rows-1 h-10">
            <div class="grid grid-cols-2">
              <div class="border-b-1 border-gray-500">
                <mat-form-field class="bg-white w-full" appearance="fill">
                  <input
                    matInput
                    autocomplete="off"
                    type="password"
                    formControlName="oldPassword"
                    [maxlength]="50"
                    required
                    InputText
                    [type]="hidden ? 'password' : 'text'"
                    />
                </mat-form-field>
              </div>
              <div class="items-center flex">
                <i
                  class="mx-1 uil"
                  (click)="hidden = !hidden"
                  [ngClass]="{ 'uil-eye-slash': hidden, 'uil-eye': !hidden }"
                  >
                </i>
              </div>
            </div>
          </div>

          @if (invalid(passwordForm.get('oldPassword'))) {
            <mat-error class="errorMsg z-10 relative"
              >{{ t('userProfile.password.currentRequired') }}</mat-error
              >
            }

            <div class="pt-10">
              <div class="grid-cols-1">
                <label>{{ t('userProfile.password.new') }} <span class="required"></span></label>
                <div class="grid grid-rows-1 h-10">
                  <div class="grid grid-cols-2">
                    <div class="border-b-1 border-gray-500">
                      <mat-form-field class="bg-white email w-full" appearance="fill">
                        <input
                          matInput
                          autocomplete="off"
                          type="password"
                          formControlName="newPassword"
                          [maxlength]="50"
                          required
                          InputText
                          [type]="confirmHidden ? 'password' : 'text'"
                          />
                      </mat-form-field>
                    </div>
                    <div class="items-center flex">
                      <i
                        class="mx-1 uil"
                        (click)="confirmHidden = !confirmHidden"
                        [ngClass]="{ 'uil-eye-slash': confirmHidden, 'uil-eye': !confirmHidden }"
                        >
                      </i>
                    </div>
                  </div>
                </div>
              </div>
              @if (invalid(passwordForm.get('newPassword'))) {
                <mat-error class="errorMsg z-10 relative">
                  {{ t('userProfile.password.newInvalid') }}
                </mat-error>
              }
            </div>

            <div class="pt-10">
              <label>{{ t('userProfile.password.confirm') }} <span class="required"></span></label>
              <div class="grid grid-rows-1 h-10">
                <div class="grid grid-cols-2">
                  <div class="border-b-.5 border-gray-500">
                    <mat-form-field class="bg-white email w-full" appearance="fill">
                      <input
                        matInput
                        autocomplete="off"
                        type="password"
                        formControlName="confirmPassword"
                        [maxlength]="50"
                        required
                        pInputText
                        [type]="hiddenConfirm ? 'password' : 'text'"
                        />
                    </mat-form-field>
                  </div>
                  <div class="items-center flex">
                    <i
                      class="mx-1 uil"
                      (click)="hiddenConfirm = !hiddenConfirm"
                      [ngClass]="{ 'uil-eye-slash': hiddenConfirm, 'uil-eye': !hiddenConfirm }"
                      >
                    </i>
                  </div>
                </div>
              </div>
              @if (invalid(passwordForm.get('confirmPassword'))) {
                <mat-error class="errorMsg z-10 relative">
                  {{ t('userProfile.password.mismatch') }}
                </mat-error>
              }
            </div>
          </div>

          <div class="flex justify-end mt-4">
            <drdp-btn type="submit">{{ t('userProfile.password.submit') }}</drdp-btn>
            <drdp-btn color="cancel" class="ml-3 mr-6" routerLink="/user-profile"
            >{{ t('userProfile.password.cancel') }}</drdp-btn>
          </div>

        </form>

      </div>
    </drdp-container>
  </div>
</ng-container>
